import { CooperativeSearchSelect } from '@/components/form-fields';

export const getFormFields = () => {
  return [
    {
      name: 'name',
      permissionName: 'consortium.name',
      componentName: 'input',
      params: {
        i18nLabel: 'counterparties.name',
      },
      rules: [{ required: true }],
    },
    {
      name: 'cooperativeIds',
      permissionName: 'cooperative_consortium_detail',
      componentName: 'dropdown',
      component: CooperativeSearchSelect,
      params: {
        i18nLabel: 'consortiums.cooperatives',
        allowClear: true,
        mode: 'multiple',
      },
    },
  ];
};
